import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { MEDIA_CONFIG } from '../data/media';
import ContactButton from '../components/ContactButton';

const FAQ_ITEMS = [
  {
    question: "Wie läuft ein typisches Videoprojekt ab?",
    answer: "Ein typisches Projekt durchläuft mehrere Phasen: Zunächst führen wir ein ausführliches Beratungsgespräch, in dem wir Ihre Vorstellungen und Ziele besprechen. Darauf aufbauend entwickle ich ein Konzept und erstelle ein detailliertes Angebot. Nach der Freigabe beginnt die Produktionsphase mit Dreh und Postproduktion. Sie werden während des gesamten Prozesses eng eingebunden und haben mehrere Feedback-Möglichkeiten."
  },
  {
    question: "Welche Vorlaufzeit sollte ich für ein Projekt einplanen?",
    answer: "Die Vorlaufzeit hängt von der Komplexität des Projekts ab. Für kleinere Produktionen sollten Sie mindestens 2-3 Wochen einplanen, für größere Projekte empfehle ich 6-8 Wochen Vorlauf. In dringenden Fällen können wir auch kurzfristige Produktionen realisieren - sprechen Sie mich einfach an."
  },
  {
    question: "Wie werden die Kosten für ein Projekt berechnet?",
    answer: "Die Kosten setzen sich aus verschiedenen Faktoren zusammen: Produktionsumfang, Drehtage, benötigtes Equipment und Postproduktionsaufwand. Ich erstelle Ihnen gerne ein individuelles Angebot basierend auf Ihren spezifischen Anforderungen und Ihrem Budget."
  },
  {
    question: "Welches Equipment verwenden Sie?",
    answer: "Ich arbeite mit professioneller Film- und Fototechnik auf aktuellem Stand. Dazu gehören hochwertige Kameras von Sony und Canon, professionelle Lichttechnik sowie modernste Postproduktions-Workstations. Das konkrete Equipment wähle ich entsprechend den Anforderungen Ihres Projekts aus."
  },
  {
    question: "Bieten Sie auch Fotografie an?",
    answer: "Ja, ich biete professionelle Fotografie für verschiedene Bereiche an: Von Businessfotografie über Portraitaufnahmen bis hin zu Event-Dokumentation. Dabei kann ich Foto- und Videoproduktion optimal kombinieren."
  },
  {
    question: "Wie läuft die Zusammenarbeit bei internationalen Projekten ab?",
    answer: "Ich habe Erfahrung mit internationalen Produktionen und kann weltweit arbeiten. Die Kommunikation erfolgt digital, und ich stelle sicher, dass alle Zeitpläne und Anforderungen koordiniert werden."
  },
  {
    question: "Welche Rechte erhalte ich an den produzierten Medien?",
    answer: "Nach vollständiger Bezahlung erhalten Sie umfassende Nutzungsrechte an allen produzierten Medien für Ihre Kommunikationskanäle. Die genauen Nutzungsrechte werden im Vorfeld vertraglich festgehalten."
  },
  {
    question: "Bieten Sie auch Support nach Projektabschluss?",
    answer: "Ja, ich biete auch nach Projektabschluss Support an. Dazu gehören technische Unterstützung, Formatanpassungen für verschiedene Plattformen und die sichere Archivierung Ihrer Medien."
  }
];

function FAQ() {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setOpenItems(prev => 
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div className="min-h-screen bg-black text-white pt-20">
      {/* Hero Section */}
      <div className="relative h-[40vh] flex items-center justify-center overflow-hidden">
        <img
          src={`${MEDIA_CONFIG.paths.backgrounds}/headers/faq-header.jpg`}
          alt="FAQ Header"
          className="absolute w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">FAQ</h1>
          <p className="text-xl max-w-2xl mx-auto">
            Häufig gestellte Fragen und Antworten
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-4">
          {FAQ_ITEMS.map((item, index) => (
            <div
              key={index}
              className="bg-zinc-900 rounded-lg overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 flex items-center justify-between text-left"
                onClick={() => toggleItem(index)}
              >
                <span className="text-lg font-medium">{item.question}</span>
                {openItems.includes(index) ? (
                  <ChevronUp className="flex-shrink-0 ml-4" />
                ) : (
                  <ChevronDown className="flex-shrink-0 ml-4" />
                )}
              </button>
              
              <div
                className={`px-6 transition-all duration-200 ease-in-out ${
                  openItems.includes(index)
                    ? 'max-h-96 py-4 opacity-100'
                    : 'max-h-0 py-0 opacity-0'
                }`}
              >
                <p className="text-gray-400">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-400 mb-6">
            Haben Sie weitere Fragen? Kontaktieren Sie mich!
          </p>
          <ContactButton />
        </div>
      </div>
    </div>
  );
}

export default FAQ;